module.exports = {
  lastfmUser: 'corygibbons',
  lastfmApiKey: '04e753683a07d69478df0c4729133923',
  googleAnalyticsKey: 'UA-55497622-4'
}



//////////////////
// WEBPACK FOOTER
// ./config.js
// module id = 93
// module chunks = 0